// extracted by mini-css-extract-plugin
export default {"item":"ttWdElOR9vBuV4RobMbY"};